import * as React from 'react';
import { Circle, Path } from 'react-native-svg';

function Piercings() {
  return (
    <>
      <Path
        d="M62.73 101.88a4.68 4.68 0 00-.55 2.28 1.65 1.65 0 00.09 1.5 3.53 3.53 0 003.38 1.34 6.41 6.41 0 003.92-1.28 2.43 2.43 0 00.81-1.52 2.32 2.32 0 00.3-2.13 2.84 2.84 0 011.68 2.39 4.44 4.44 0 01-1.44 2.73 6.35 6.35 0 01-2.53 1.37 11.1 11.1 0 01-2.66.43 7.12 7.12 0 01-2.81-.38 4.58 4.58 0 01-2.37-2 3.73 3.73 0 01-.25-3.22 4 4 0 012.43-1.51z"
        fill="#e3c011"
      />
      <Circle
        cx={94.4}
        cy={77.78}
        r={1.1}
        fill="#eccb41"
        stroke="#e3c011"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={0.68}
      />
      <Circle
        cx={95.5}
        cy={82.52}
        r={1.1}
        fill="#eccb41"
        stroke="#e3c011"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={0.68}
      />
      <Circle
        cx={47.09}
        cy={119.85}
        r={1.36}
        fill="#eccb41"
        stroke="#e3c011"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={0.84}
      />
      <Circle
        cx={85.28}
        cy={124.18}
        r={1.36}
        fill="#eccb41"
        stroke="#e3c011"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={0.84}
      />
    </>
  );
}

export default Piercings;
